/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import PatchLabelDialog from "../PatchLabelDialog";
import {
  useCreateReleaseLabel,
  useListAllReleasesWithDetails,
  useUpdateReleaseStatus,
} from "../../../api/releases";
import Notification, {
  useNotification,
} from "../../../components/Notification";
import styles from "../styles";
import ReleaseCard from "./ReleaseCard";
import { useConfirmationDialog } from "../../../components/ConfirmationDialog";

const patchLabelDialogDefault = {
  isOpen: false,
  release: "",
};

const ReleaseSummaryView = ({ selectedAppGroup }) => {
  const [releases, setReleases] = useState([]);
  const [patchLabelDialog, setPatchLabelDialog] = useState(
    patchLabelDialogDefault
  );
  const [notify, setNotify] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const { notificationComponent, displayNotification } = useNotification();

  const {
    postData: listAllReleasesWithDetails,
    response: listAllReleasesWithDetailsResp,
  } = useListAllReleasesWithDetails(selectedAppGroup);

  const updateReleaseStatusHook = useUpdateReleaseStatus(selectedAppGroup);
  const {
    confirmationDialog: releaseStatusDialog,
    showConfirmationDialog: showReleaseStatusDialog,
  } = useConfirmationDialog(
    `Update Release Status for ${selectedAppGroup}`,
    () => updateReleaseStatusHook,
    displayNotification,
    listAllReleasesWithDetails
  );

  const {
    postData: createReleaseLabel,
    response: createReleaseLabelResp,
    responseStatus: createReleaseLabelRespStatus,
  } = useCreateReleaseLabel(selectedAppGroup);

  useEffect(() => {
    listAllReleasesWithDetails();
  }, [selectedAppGroup]);

  useEffect(() => {
    if (Array.isArray(listAllReleasesWithDetailsResp?.releases)) {
      setReleases(listAllReleasesWithDetailsResp.releases);
    }
  }, [listAllReleasesWithDetailsResp]);

  useEffect(() => {
    if (createReleaseLabelResp) {
      listAllReleasesWithDetails();
    }
  }, [createReleaseLabelResp]);

  const handlePatchLabel = (release, notReadOnly) => {
    const releaseName = release;
    const releaseNumber = releaseName.split("-")[1];
    const transformedRelease = `rel-0.${releaseNumber}.0`;
    setPatchLabelDialog({
      isOpen: true,
      release: transformedRelease,
      notReadOnly: notReadOnly,
      releaseName: releaseName,
    });
  };
  const resetDialog = () => {
    setPatchLabelDialog(patchLabelDialogDefault);
  };

  useEffect(() => {
    const message =
      createReleaseLabelResp?.message ||
      createReleaseLabelResp?.detail?.message ||
      createReleaseLabelResp?.detail;
    if (message?.length && typeof createReleaseLabelRespStatus === "number") {
      setMessage(message);
      setSeverity(createReleaseLabelRespStatus < 300 ? "success" : "error");
      setNotify(true);
    }
  }, [createReleaseLabelResp, createReleaseLabelRespStatus]);

  return (
    <>
      {notificationComponent}
      {releaseStatusDialog}
      <Notification
        notify={notify}
        severity={severity}
        setNotify={setNotify}
        message={message}
      />
      <PatchLabelDialog
        selectedAppGroup={selectedAppGroup}
        patchLabelDialog={patchLabelDialog}
        createReleaseLabel={createReleaseLabel}
        resetDialog={resetDialog}
      />
      <Grid container spacing={2} sx={styles.summaryViewStyle}>
        {releases?.map((release) => (
          <ReleaseCard
            key={release?.name}
            release={release}
            handlePatchLabel={handlePatchLabel}
            app={selectedAppGroup}
            showReleaseStatusDialog={showReleaseStatusDialog}
          />
        ))}
      </Grid>
    </>
  );
};

export default ReleaseSummaryView;
